class AuthorArticleList {
    constructor(el) {
        this.scope = el;
        this.loadMore = el.querySelector('[data-load-more]');
        this.maxPage = parseInt(this.loadMore.dataset.maxPage);
        this.currentPage = parseInt(this.loadMore.dataset.currentPage);
        if (this.currentPage === this.maxPage) {
            this.hideLoadMore()
        }
        this.bindEvents();
    }

    bindEvents() {
        if (this.loadMore) {
            this.loadMore.addEventListener("click", () => {
                if (this.currentPage < this.maxPage) {
                    this.handleLoadMore(this.loadMore.dataset.author, this.currentPage, this.maxPage);
                }
            })
        }
    }

    handleLoadMore(author, currentPage, maxPage) {
        const resultsWrapper = this.scope.querySelector('[data-results]');
        fetch(`/umbraco/surface/AuthorArticleList/LoadMore?author=${author}&currentPage=${currentPage}`)
            .then(response => response.text())
            .then(data => {
                if (resultsWrapper) {
                    resultsWrapper.innerHTML += data;
                    this.currentPage += 1
                    this.loadMore.dataset.currentPage = this.currentPage;
                    if (this.currentPage === this.maxPage)
                    {
                        this.hideLoadMore()
                    }
                }
            });
    }

    hideLoadMore() {
        this.loadMore.classList.add('hidden');
    }
}

ControlBinders.register(`.author-teaser-wrap-block`, el => new AuthorArticleList(el));